import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Dashboard from '../components/Dashboard';
import Login from '../components/Login';
import Users from '../components/Users';
import Actions from '../components/Actions';
import Action from '../components/Action';
import User from '../components/User';
import ActionStats from '../components/ActionStats';
import Notification from '../components/Notification';
import Notifications from '../components/Notifications';
import NotFound from '../components/NotFound';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/actions/:id',
      component: Actions,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user',
      component: User,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId',
      component: User,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId/action/:actionId',
      component: Action,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId/action',
      component: Action,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/action/:actionId/stats',
      component: ActionStats,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId/action/:actionId/notification/add',
      component: Notification,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId/action/:actionId/notification/:notificationId',
      component: Notification,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:userId/action/:actionId/notifications',
      component: Notifications,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    { path: '*', component: NotFound }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
